/**
 * Widths the fixed booking panel lays its columns out at. They are measured on
 * the panel itself (a CSS query container), not on the viewport: beside the cart
 * a wide screen still leaves the panel too narrow for three columns.
 */

export const FIXED_BOOKING_CONTAINER = 'pf-fixed-booking'

/** Calendar (38.4rem) beside a usable time column. */
export const FIXED_BOOKING_TWO_COLUMN_WIDTH = 600

/** Calendar beside a usable time column and a creative column whose names do not break mid-word. */
export const FIXED_BOOKING_THREE_COLUMN_WIDTH = 860

/** From here the time sits beside the calendar. */
export const FIXED_BOOKING_TWO_COLUMNS = `@container ${FIXED_BOOKING_CONTAINER} (width >= ${FIXED_BOOKING_TWO_COLUMN_WIDTH}px)`

/** From here the creatives join them as a third column. */
export const FIXED_BOOKING_THREE_COLUMNS = `@container ${FIXED_BOOKING_CONTAINER} (width >= ${FIXED_BOOKING_THREE_COLUMN_WIDTH}px)`
